import * as board from "./board";
import * as center from "./center";
import * as clover from "./clover";
import * as common from "./common";
import * as dshop from "./dshop";
import * as form from "./form";
import * as gshop from "./gshop";
import * as history from "./history";
import * as hunt from "./hunt";
import * as me from "./me";
import nanuri from "./nanuri";
import nshop from "./nshop";
import * as roulette from "./roulette";
import * as shop from "./shop";
import * as theme from "./theme";
import * as user from "./user";

export const v1 = {
    ...board,
    ...center,
    ...clover,
    ...common,
    ...dshop,
    ...form,
    ...gshop,
    ...history,
    ...hunt,
    ...me,
    nanuri,
    nshop,
    ...roulette,
    ...shop,
    ...theme,
    ...user,
};
